import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const UserSingle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 19.714V18.43c0-1.023.442-2.005 1.23-2.728s1.856-1.13 2.97-1.13h5.6c1.114 0 2.182.407 2.97 1.13S19 17.406 19 18.43v1.285c0 .341-.148.668-.41.91a1.47 1.47 0 0 1-.99.376H6.4c-.371 0-.727-.136-.99-.377a1.24 1.24 0 0 1-.41-.909M16.2 6.857c0 1.023-.442 2.004-1.23 2.728-.788.723-1.856 1.13-2.97 1.13s-2.182-.407-2.97-1.13C8.243 8.86 7.8 7.88 7.8 6.857s.442-2.004 1.23-2.727C9.818 3.406 10.886 3 12 3s2.182.406 2.97 1.13c.787.723 1.23 1.704 1.23 2.727"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(UserSingle) as SvgIcon;
export { ForwardRef as ReactComponent };
